import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import {
  TXTCLI_About_you,
  TXTCLI_Deposit_1,
  TXTWCL_Account_details,
  TXTWCL_Bonus_applied
} from './ProgressBarsContent.messages.json';

const ProgressBarsContent = () => (
  <div>
    <Translation tagName="div" {...TXTWCL_Account_details} />
    <Translation tagName="div" {...TXTCLI_About_you} />
    <Translation tagName="div" {...TXTCLI_Deposit_1} />
    <Translation tagName="div" {...TXTWCL_Bonus_applied} />
  </div>
);

export default ProgressBarsContent;
